import React, { useState } from 'react';
import FuelConsumptionMCR from './FuelConsumptionMCR';
import PropRPMvsMCR from './PropRPMvsMCR';
import FuelConsumptionRPM from './FuelConsumptionRPM';
// import SpeedFuelAlternate from './SpeedFuelAlternate';
import { Cpu } from 'lucide-react'; // Using a different icon for differentiation

const EnginePropulsionAnalysis = ({ fuelVsMCR, rpmVsMCR, fuelVsRPM }) => {
  const [activeGraph, setActiveGraph] = useState('fuelMCR');

  const graphComponents = {
    fuelMCR: <FuelConsumptionMCR data={fuelVsMCR} />,
    // rpmMCR: <PropRPMvsMCR data={rpmVsMCR} />,
    // fuelRPM: <FuelConsumptionRPM data={fuelVsRPM} />,
        rpmMCR: <PropRPMvsMCR data={fuelVsRPM} />,
    fuelRPM: <FuelConsumptionRPM data={rpmVsMCR} />,
  };

  const getButtonStyle = (graphKey) => {
    const isActive = activeGraph === graphKey;
    const baseColor = '#27ade3'; // indigo-500
    
    return isActive 
      ? { 
          backgroundColor: `${baseColor}20`, // 20% opacity
          color: baseColor,
          borderColor: baseColor
        }
      : {};
  };

  return (
    <div className="bg-white rounded-lg border border-gray-200 shadow-sm overflow-hidden">
      {/* Header */}
      <div className="px-6 py-4 border-b border-gray-200 flex flex-col sm:flex-row sm:items-center sm:justify-between gap-4">
        <div className="flex items-center gap-3">
          <div className="p-1.5 bg-[#e1f5fb] text-[#27ade3] rounded-md" >
            <Cpu className="w-5 h-5" />
          </div>
          <h2 className="text-lg font-semibold text-gray-900">
            Engine & Propulsion Analysis
          </h2>
        </div>

        <div className="flex gap-2 flex-wrap">
          <button
            onClick={() => setActiveGraph('fuelMCR')}
            className={`px-3 py-1.5 text-sm rounded-md transition-colors ${
              activeGraph === 'fuelMCR'
                ? 'font-medium border'
                : 'bg-gray-100 text-gray-600 hover:bg-gray-200'
            }`}
            style={getButtonStyle('fuelMCR')}
          >
            Fuel vs. % MCR
          </button>
          <button
            onClick={() => setActiveGraph('rpmMCR')}
            className={`px-3 py-1.5 text-sm rounded-md transition-colors ${
              activeGraph === 'rpmMCR'
                ? 'font-medium border'
                : 'bg-gray-100 text-gray-600 hover:bg-gray-200'
            }`}
            style={getButtonStyle('rpmMCR')}
          >
            RPM vs. % MCR
          </button>
          <button
            onClick={() => setActiveGraph('fuelRPM')}
            className={`px-3 py-1.5 text-sm rounded-md transition-colors ${
              activeGraph === 'fuelRPM'
                ? 'font-medium border'
                : 'bg-gray-100 text-gray-600 hover:bg-gray-200'
            }`}
            style={getButtonStyle('fuelRPM')}
          >
            Fuel vs. RPM
          </button>
          {/* <button
            onClick={() => setActiveGraph('speedFuelAlt')}
            className={`px-3 py-1.5 text-sm rounded-md transition-colors ${
              activeGraph === 'speedFuelAlt'
                ? 'font-medium border'
                : 'bg-gray-100 text-gray-600 hover:bg-gray-200'
            }`}
            style={getButtonStyle('speedFuelAlt')}
          >
            Speed vs. Fuel
          </button> */}
        </div>
      </div>

      {/* Chart Container */}
      <div className="p-4 bg-gray-50">
        <div className="bg-white rounded-lg border border-gray-200 p-4">
          {graphComponents[activeGraph]}
        </div>
      </div>
    </div>
  );
};

export default EnginePropulsionAnalysis;